export enum DomipFunction {
  DesoDoorControl = 'DesoDoorControl',
}
